import { HashRouter, Route, Routes } from "react-router-dom";
import { LoginPage, RequireAuth } from "@/features/auth/public";
import { NetworkTopologyPage } from "@/features/network-topology/public";
import { SceneEditorPage } from "@/features/scene-editor/public";
import { AppLayout } from "@/pages/AppLayout";
import { SimulationPage } from "@/pages/SimulationPage";
import { AppProviders } from "@/providers/AppProviders";

/**
 * ルーター + プロバイダ + ページ構成のトップ。
 *
 * HashRouter を採用しており、静的ホスティング (CloudFront + S3) でも
 * サーバ側 fallback 設定なしに動作する。
 */
export function App() {
  return (
    <AppProviders>
      <HashRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            element={
              <RequireAuth>
                <AppLayout />
              </RequireAuth>
            }
          >
            <Route path="/" element={<SimulationPage />} />
            <Route path="/editor" element={<SceneEditorPage />} />
            <Route path="/network" element={<NetworkTopologyPage />} />
          </Route>
        </Routes>
      </HashRouter>
    </AppProviders>
  );
}
